<template>
  <div style="margin-top: 50px; background-color: #f5f6fa">
    <div class="hero">
      <div class="hero-ctn">
        <h1 style="margin: 16px">Portfolio</h1>
        <p style="
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            text-align: center;
          ">
          {{ $t('portfolioDescriotion') }}
        </p>
      </div>
    </div>
    <div style="background-color: #f5f6fa">
      <div style="background-color: #f5f6fa">
        <div class="container">
          <div class="d-flex" style="margin-top: 21px; overflow-x: auto; padding-bottom: 20px;scrollbar-width: none;">
            <div class="inactive" @click="getPortfolio(data.value)" :class="{ active: category === data.value }"
              v-for="(data, idx) in categoryList" :key="idx">
              <span>{{ data.name }}</span>
            </div>
          </div>
          <div class="card" style="padding-bottom: 60px">
            <EmptyData v-if="!portfolio || !portfolio.length" message="Belum ada portofolio saat ini" />
            <div class="items" v-for="(item, idx) in portfolio" :key="idx"
              @click="goToProjectDetail(item.id, item.program)">
              <div style="height: 240px">
                <img :src="item.image_url" alt="" style="
                    width: 100%;
                    height: 100%;
                    border-radius: 20px 20px 0 0;
                  " />
              </div>
              <div class="content">
                <div style="height: 70px">
                  <h2>{{ item.program }}</h2>
                </div>
                <p class="content-title-p">{{ item.title }}</p>
                <p class="description-class">{{ item.description }}</p>
              </div>
            </div>
            <div v-if="currentPage < total" style="display: flex; justify-content: center">
              <Button :name="$t('loadMore')" width="440px" @click="page" outline="true" outlinecolor="true" />
            </div>
          </div>
        </div>
      </div>
      <v-card elevation="0" class="call-center-container">
        <v-row style="padding: 40px 0px">
          <v-col cols="12">
            <div class="call-center-title">
              {{ $t('portfolioHelpTitle') }}
            </div>
            <div class="call-center-desc">
              {{ $t('portfolioHelpDescription') }}
            </div>
          </v-col>
          <v-col cols="12" class="call-center-button" @click="sendWa">
            <v-btn class="btn" elevation="0"> {{ $t('portfolioAct') }} </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import Button from "../../others/Button.vue";
import EmptyData from "../../others/EmptyData.vue";

export default {
  name: "MobilePortfolio",
  components: {
    Button,
    EmptyData,
  },
  data() {
    return {
      portfolio: [],
      currentPage: 1,
      perPage: 9,
      total: 1,
      category: "SERVICES",
      categoryList: [
        {
          name: "IT Resourcing",
          value: "SERVICES",
        },
        {
          name: "Corporate Collaboration",
          value: "COLLABORATION",
        },
        {
          name: "Pelatihan Karyawan",
          value: "TRAINING",
        },
      ],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getPortfolio();
    },
  },
  methods: {
    sendWa() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Redirect to Corporate Page - Mobile Portfolio Page',
        value: 1,
      });
      this.$router.push("/corporate");
    },
    page() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Load More - Page ${this.currentPage + 1} - Mobile Portfolio Page`,
        value: 1,
      });
      this.currentPage++;
      this.getPortfolio();
    },
    async getPortfolio(e) {
        const resp = await this.$http.get(
          `/v1/project-portfolio?category=${e}&page=${this.currentPage}&per_page=${this.perPage}`
        );
        this.portfolio = resp.data.data.project_portfolios;
        if (resp.data.data.total) this.total = Math.ceil(resp.data.data.total / this.perPage);
        this.category = e;
    },
    goToProjectDetail(id, program) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Project Detail - ${program} - Mobile Portfolio Page`,
        value: 1,
      });
      this.$router.push(`/portfolio/detail/${id}`);
    }
  },
  mounted() {
    this.category = this.$route.params.category ?? 'SERVICES';
    this.getPortfolio(this.category);
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style scoped src="./portfolio.css"></style>